import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { ThemeProvider } from "next-themes";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { Toaster } from "@/components/ui/sonner";
import Layout from "@/components/Layout";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import Developments from "@/pages/Developments";
import Deploys from "@/pages/Deploys";
import Risks from "@/pages/Risks";
import Settings from "@/pages/Settings";
import UsersPage from "@/pages/UsersPage";
import TasksPage from "@/pages/TasksPage";
import MyWork from "@/pages/MyWork";
import ReportsPage from "@/pages/ReportsPage";
import OrgChart from "@/pages/OrgChart";
import Requirements from "@/pages/Requirements";
import Solicitudes from "@/pages/Solicitudes";

function Protected({ children }) {
  const { user, loading } = useAuth();
  const location = useLocation();
  if (loading || user === null) {
    return <div className="min-h-screen flex items-center justify-center text-slate-400">Cargando...</div>;
  }
  if (!user) return <Navigate to="/login" state={{ from: location }} replace />;
  return <Layout>{children}</Layout>;
}

function AppRoutes() {
  const { user } = useAuth();
  return (
    <Routes>
      <Route path="/login" element={user ? <Navigate to="/" replace /> : <Login />} />
      <Route path="/" element={<Protected><Dashboard /></Protected>} />
      <Route path="/mi-trabajo" element={<Protected><MyWork /></Protected>} />
      <Route path="/desarrollos" element={<Protected><Developments /></Protected>} />
      <Route path="/requerimientos" element={<Protected><Requirements /></Protected>} />
      <Route path="/solicitudes" element={<Protected><Solicitudes /></Protected>} />
      <Route path="/tareas" element={<Protected><TasksPage /></Protected>} />
      <Route path="/deploys" element={<Protected><Deploys /></Protected>} />
      <Route path="/riesgos" element={<Protected><Risks /></Protected>} />
      <Route path="/reportes" element={<Protected><ReportsPage /></Protected>} />
      <Route path="/organigrama" element={<Protected><OrgChart /></Protected>} />
      <Route path="/usuarios" element={<Protected><UsersPage /></Protected>} />
      <Route path="/config" element={<Protected><Settings /></Protected>} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

function App() {
  return (
    <ThemeProvider attribute="class" defaultTheme="light" enableSystem={false} storageKey="devflow-theme" disableTransitionOnChange>
      <div className="App">
        <AuthProvider>
          <BrowserRouter>
            <AppRoutes />
            <Toaster position="bottom-right" />
          </BrowserRouter>
        </AuthProvider>
      </div>
    </ThemeProvider>
  );
}

export default App;
